const SLAB_REGEX = new RegExp(
  `^(?:https?://)?${document.location.host}/(drafts|posts|users|topics|groups)/(?:[^#]*-)?([a-z0-9]+(?:#.+)?)/?$`,
);

export default function matchEntityLink(
  link: string,
): { id: string; type: 'user' | 'topic' | 'group' | 'post' } | null {
  const [path, id] = link.match(SLAB_REGEX)?.slice(1) ?? [];
  if (id) {
    switch (path) {
      case 'users':
        return { id, type: 'user' };
      case 'topics':
        return { id, type: 'topic' };
      case 'groups':
        return { id, type: 'group' };
      default:
        return { id, type: 'post' };
    }
  }

  return null;
}
